<template>
	<div class="pages">
		<navTop></navTop>
		<div class="box">
			<div class="content">
				<p class="title">Personal Information</p>
				<li class="li">
					<input type="text" v-model="infoList.mail" placeholder="Please enter your email" />
					<img
						v-if="infoList.mail.length > 0"
						@click="infoList.mail = ''"
						src="../../assets/del.png"
						alt=""
					/>
				</li>
				<li class="li">
					<input type="text" v-model="infoList.name" placeholder="Please enter your name" />
					<img
						v-if="infoList.name.length > 0"
						@click="infoList.name = ''"
						src="../../assets/del.png"
						alt=""
					/>
				</li>
				<li class="li">
					<input
						type="text"
						v-model="infoList.company"
						placeholder="Please enter your company name"
					/>
					<img
						v-if="infoList.company.length > 0"
						@click="infoList.company = ''"
						src="../../assets/del.png"
						alt=""
					/>
				</li>
				<li class="li">
					<input type="text" v-model="infoList.address" placeholder="Please enter your address" />
					<img
						v-if="infoList.address.length > 0"
						@click="infoList.address = ''"
						src="../../assets/del.png"
						alt=""
					/>
				</li>
				<li class="li2">
					<el-upload
						class="avatar-uploader"
						:action="imageUrl"
						:show-file-list="false"
						:on-success="getUpload1"
					>
						<img v-if="infoList.businessLicense" :src="infoList.businessLicense" class="avatar" />
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<span>Business License Of A Corporation</span>
				</li>
				<li class="li2">
					<el-upload
						class="avatar-uploader"
						:action="imageUrl"
						:show-file-list="false"
						:on-success="getUpload2"
						style="width: 73px;height: 73px;"
					>
						<img v-if="infoList.logo" :src="infoList.logo" class="avatar" />
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					<span>Company Logo</span>
				</li>
				<li class="li">
					<input
						type="text"
						v-model="infoList.phone"
						@input="infoList.phone = infoList.phone.replace(/[^\d]/g, '')"
						placeholder="Please enter your mobile phone number"
						maxlength="11"
					/>
					<img
						v-if="infoList.phone.length > 0"
						@click="infoList.phone = ''"
						src="../../assets/del.png"
						alt=""
					/>
				</li>
				<li class="li">
					<input type="text" v-model="infoList.webSite" placeholder="Company website (optional)" />
					<img
						v-if="infoList.webSite.length > 0"
						@click="infoList.webSite = ''"
						src="../../assets/del.png"
						alt=""
					/>
				</li>
				<li class="btn" @click="subimt">Preservation</li>
			</div>
		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
export default {
	name: 'user',
	components: {
		navTop
	},
	data() {
		return {
			infoList: []
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.infoList = JSON.parse(sessionStorage.getItem('infoList'));
		}
	},
	methods: {
		// 上传营业执照
		getUpload1(res, file) {
			this.infoList.businessLicense = res.url;
		},
		// 上传公司logo
		getUpload2(res, file) {
			this.infoList.logo = res.url;
		},
		subimt() {
			if (this.infoList.mail == '') {
				this.$message({
					message: 'Please fill in the email',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			if (this.infoList.name == '') {
				this.$message({
					message: 'Please fill in your name',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			if (this.infoList.company == '') {
				this.$message({
					message: 'Please fill in the company name',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			if (this.infoList.address == '') {
				this.$message({
					message: 'Please fill in the company address',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			if (this.infoList.businessLicense == '') {
				this.$message({
					message: 'Please upload the companys business license',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			if (this.infoList.logo == '') {
				this.$message({
					message: 'Please upload company Logo',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
			if (!myreg.test(this.infoList.phone)) {
				this.$message({
					message: 'Mobile phone number input error!',
					type: 'error',
					center: true,
					duration: 1000
				});
				return;
			}
			let data = {
				uid: sessionStorage.getItem('uid'),
				mail: this.infoList.mail,
				name: this.infoList.name,
				company: this.infoList.company,
				webSite: this.infoList.webSite,
				address: this.infoList.address,
				businessLicense: this.infoList.businessLicense,
				logo: this.infoList.logo,
				phone: this.infoList.phone
			};
			this.$api.update(data).then((res) => {
				console.log(res);
				if (res.result == 0) {
					let that = this;
					that.getInfo();
					that.$message({
						message: 'Modified successfully',
						type: 'success',
						center: true,
						duration: 1000,
						onClose: function() {
							that.$router.push({ path: '/index' });
						}
					});
				} else {
					this.$message({
						message: res.resultNote,
						type: 'error',
						center: true,
						duration: 1000
					});
				}
			});
		},
		// 获取个人信息
		getInfo() {
			let data = {
				uid: sessionStorage.getItem('uid')
			};
			this.$api.info(data).then((res) => {
				console.log(res);
				if (res.result == 0) {
					sessionStorage.setItem('infoList', JSON.stringify(res.data));
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.pages {
	background: #000;
	.box {
		width: 100%;
		height: 1092px;
		background-image: url('../../assets/user-bg.png');
		background-size: 100% 100%;
		padding-top: 100px;
		box-sizing: border-box;
		.content {
			width: 514px;
			height: 861px;
			background-image: url('../../assets/user-bg2.png');
			background-size: 100% 100%;
			margin: 0 auto;
			padding: 30px 67px 50px;
			box-sizing: border-box;
			.title {
				font-size: 30px;
				font-family: Adobe Heiti Std;
				font-weight: normal;
				color: #06fffd;
				text-align: center;
				margin-bottom: 5px;
			}
			.li {
				height: 71px;
				border-bottom: 1px solid #06fffd;
				display: flex;
				align-items: center;
				input {
					width: 100%;
					height: 69px;
					background: #060c18;
					border: none;
					font-size: 14px;
					outline: none;
					color: #13fffc;
					padding: 0 10px;
					box-sizing: border-box;
				}
				img {
					width: 16px;
					height: 16px;
					display: block;
				}
			}
			.li2 {
				padding-top: 25px;
				box-sizing: border-box;
				display: flex;
				align-items: flex-end;
				.avatar-uploader {
					width: 73px;
					height: 101px;
					display: flex;
					justify-content: center;
					align-items: center;
					border: 1px solid #1a4e54;
					box-sizing: border-box;
					.avatar-uploader-icon {
						font-size: 30px;
						font-weight: 100;
						color: #ffffff;
					}
				}
				.avatar {
					width: 100%;
					height: 100%;
					display: block;
				}
				span {
					font-weight: 300;
					color: #06fffd;
					margin-left: 15px;
				}
			}
			.btn {
				width: 379px;
				height: 60px;
				background: linear-gradient(
					90deg,
					rgba(26, 175, 170, 0.8) 0%,
					rgba(29, 255, 247, 0.8) 100%
				);
				font-size: 20px;
				font-family: PingFang SC;
				font-weight: bold;
				color: #f6f6f6;
				text-align: center;
				line-height: 60px;
				margin-top: 26px;
			}
		}
	}
}
</style>
>
